import { bunja } from 'bunja';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import Num from '@flipster/utils/num';

import { addPositionModalBunja } from '../state';
import { addPositionValidationBunja } from '../validation-state';

export const addPositionStepBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { positionAtom, instrumentAtom, inputModeAtom, targetPriceAtom, inputValueAtom, isBboCheckedAtom } =
    bunja.use(addPositionModalBunja);
  const { maxAvailableMarginAtom } = bunja.use(addPositionValidationBunja);

  const handleChangeBboChecked = (checked: boolean) => {
    store.set(isBboCheckedAtom, checked);
  };

  const updateValueByPercent = (percent: number) => {
    const instrument = store.get(instrumentAtom);
    const position = store.get(positionAtom);
    const inputMode = store.get(inputModeAtom);
    const targetPrice = store.get(targetPriceAtom);

    const maxAvailableMargin = Num(store.get(maxAvailableMarginAtom));

    switch (inputMode) {
      case 'margin': {
        const newMargin = maxAvailableMargin.multipliedBy(percent).dividedBy(100).toFixed(2);
        store.set(inputValueAtom, newMargin);
        break;
      }
      case 'positionSize': {
        const maxAvailablePositionSize = maxAvailableMargin.multipliedBy(position.initLeverage);
        const newPositionSize = maxAvailablePositionSize.multipliedBy(percent).dividedBy(100).toFixed(2);
        store.set(inputValueAtom, newPositionSize);
        break;
      }
      case 'qty': {
        if (!targetPrice || Num(targetPrice).isZero()) {
          store.set(inputValueAtom, '0');
          return;
        }
        const slippage = instrument.defaultMaxSlippage ? Num(1).minus(instrument.defaultMaxSlippage) : Num('0.99');
        const maxAvailablePositionSize = maxAvailableMargin.multipliedBy(position.initLeverage);
        const maxAvailableQty = maxAvailablePositionSize.dividedBy(targetPrice).multipliedBy(slippage);
        const newQty = maxAvailableQty.multipliedBy(percent).dividedBy(100).toFixed(instrument.tradeQtyPrecision);
        store.set(inputValueAtom, newQty);
        break;
      }
      default:
        break;
    }
  };

  return {
    handleChangeBboChecked,
    updateValueByPercent,
  };
});
addPositionStepBunja.debugLabel = 'addPositionStepBunja';
